import React from 'react';
import { findDOMNode } from 'react-dom';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { IFRAME_RESIZED, CONF_MENU_CHANGE } from '../../settings/events';
import emitter from '../../emitter';
import TransitionTarget from '../Transition/TransitionTarget';
import Portal from '../utils/Portal';
import Outline from '../Outline';
import styles from './Modal.module.less';
import popupStyles from '../Popup/Popup.module.less';
import Popup from '../Popup';

export default class Modal extends TransitionTarget {
  static propTypes = {
    calculateTargetRect: PropTypes.func,
    children: PropTypes.node,
    className: PropTypes.string,
    container: PropTypes.string,
    onClose: PropTypes.func,
    outlineTarget: PropTypes.bool,
    target: PropTypes.any,
    targetRect: PropTypes.object,
  };

  classNames = styles;

  state = {};

  componentDidMount() {
    if (this.props.outlineTarget) {
      this._setTargetRect();

      emitter.on(IFRAME_RESIZED, this._setTargetRect);
      emitter.on(CONF_MENU_CHANGE, this._setTargetRect);
    }
  }

  componentWillUnmount() {
    emitter.off(IFRAME_RESIZED, this._setTargetRect);
    emitter.off(CONF_MENU_CHANGE, this._setTargetRect);
  }

  onModalClose = () => {
    this.props.onClose();
  };

  _setTargetRect = () => {
    const { calculateTargetRect, targetRect, target } = this.props;

    let rect;

    if (targetRect) {
      rect = targetRect;
    } else if (calculateTargetRect) {
      rect = calculateTargetRect();
    } else if (target) {
      const DOMNode = target instanceof Element ? target : findDOMNode(target);

      rect = DOMNode.getBoundingClientRect();
    } else {
      throw Error(
        'You need to pass target, targetRect or calculateTargetRect to Popup'
      );
    }

    this.setState({
      targetRect: rect,
    });
  };

  render() {
    const { className, container, onClose, transitionState, outlineTarget } =
      this.props;
    const { targetRect } = this.state;
    const target = document.querySelector('#canvas-container');
    return (
      <React.Fragment>
        <Portal container={container}>
          <div
            className={classNames(
              styles.wrapper,
              className,
              this.getTransitionClassNames(),
              popupStyles['BOTTOM-aligned']
            )}
          ></div>
        </Portal>

        <Popup
          target={target}
          {...this.props}
          outlineTarget={false}
          spacing={8}
          margin={0}
          calculateTargetRect={null} // To prevent the default sprite calculation
        >
          {this.props.children}
        </Popup>

        {targetRect && outlineTarget && (
          <Outline
            transitionState={transitionState}
            targetRect={targetRect}
            onClose={onClose}
          />
        )}
      </React.Fragment>
    );
  }
}
